<template>
  <div id="app">
    <router-view></router-view>
  </div>
</template>

<script>
export default {
  name: 'App'
};
</script>

<style>
/* 可以在这里添加全局样式 */
body{
  padding: 0px;
  margin: 0px;
  background: #efefef;
}
.app-box{
  padding: 10px;
  margin: 0px;
}
.cc-con{
  background: #ffffff;
  height: 86vh;
  overflow-y: auto;
  width: 96vw;
  margin: 0 auto;
  border-radius: 10px;
}
.cc-con-box{
  display: flex;
  flex-direction: column;
}
.cc-con-box-title{
  font-size: 18px;
  color: #333;
  font-weight: bold;
  margin-left: 8px;
  padding: 10px;
  border-bottom: 1px solid #efefef;
}
.cc-con-box-content{
  padding: 10px;
}
.top-box {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 10px 20px;
  background-color: #f8f9fa;
  border-bottom: 1px solid #e9ecef;
  margin-bottom: 10px;
  border-radius: 10px;
}

.logo {
  display: flex;
  align-items: center;
  cursor: pointer;
}

.logo img {
  height: 50px;
  margin-right: 10px;
}

.logo span {
  font-size: 2rem;
  color: #333;
}
.el-menu--horizontal>.el-menu-item.is-active,.el-sub-menu.is-active .el-sub-menu__title{
  border-bottom:none !important;
}
.top-menu {
  display: flex;
  align-items: center;
  justify-content: flex-end;
  background-color: #f8f9fa;
  padding: 0px;
}

.copy-text{
  font-size: 12px;
  color: #999;
  margin-top: 5px;
  margin-bottom: 5px;
  background: #F2F0ED;
  padding: 10px;
}

.copy-text p{
  margin: 0px;
  padding: 0px;
}

/* 自定义子菜单样式 */

.user-info{
  display: flex;
  align-items: center;
  background: #ffffff;
  padding:0px;
  cursor: pointer;
  border: 1px solid #efefef;
}
.user-link{
  display: flex;
  align-items: center;
  flex-direction: column;
  justify-content: center;
  border-radius: 15%;
  overflow: hidden;
  padding: 10px;
  width: 80px;
}
.user-link:hover{
  border:none;
}
.user-avatar{
  width:30px;
  height:30px;
  border-radius: 50%;
}
.user-name{
  font-size: 12px;
  color: #333;
  margin-top: 5px;
}
.top-menu .el-menu--horizontal.el-menu{
  border-bottom: none;
}
/* 表格样式自定义 */
.table-header{
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 10px;
}
.table-body{
  margin-top: 10px;
}
.search-btn{
  margin-left: 10px;
}

.refresh-btn{
  margin-right: 10px;
}
.loading-tips-p{
  text-align: center;
  line-height: 50px;
  width: 100%;
}
.scrollable-content {
  width: 100%;
  height: 180px; /* 占满整个对话框的高度 */
  overflow-y: auto; /* 启用垂直滚动条 */
  padding: 20px; /* 可选：添加内边距 */
  border: 1px solid #f1f1f1;
  border-radius: 6px;
}
/* 可选：自定义滚动条样式 */
.scrollable-content::-webkit-scrollbar {
  width: 8px;
}

.scrollable-content::-webkit-scrollbar-track {
  background-color: #f1f1f1;
}

.scrollable-content::-webkit-scrollbar-thumb {
  background-color: #888;
  border-radius: 4px;
}

.scrollable-content::-webkit-scrollbar-thumb:hover {
  background-color: #555;
}
.cc-w-three{
  width: 30%;
}
.cc-w-six{
  width: 60%;
}
.cc-w-nine{
  width: 90%;
}
/**平板显示**/
@media screen and (max-width: 1024px) {
  .top-box{
    flex-direction: column;
  }

  .logo img {
    margin-bottom: 10px;
  }
  .cc-w-three{
    width: 40%;
  }
  .cc-w-six{
    width: 65%;
  }
  .cc-w-nine{
    width: 90%;
  }
}


/*手机端显示*/
@media screen and (max-width: 768px) {

  .top-box{
    flex-direction: column;
  }

  .logo img {
    height: 30px;
    margin-right: 10px;
  }

  .logo span {
    font-size: 18px;
    color: #333;
  }

  .el-menu--horizontal{
    display: block !important;
    height: auto !important;
  }

  .user-link{
    width: auto;
    flex-direction: row;
    padding: 5px 10px;
    line-height: 30px;
    height: 30px;
    border-radius: 10%;
  }
  .user-name{
    margin-top: 0px;
    margin-left: 5px;
  }
  .cc-w-three{
    width: 90%;
  }
  .cc-w-six{
    width: 90%;
  }
  .cc-w-nine{
    width: 90%;
  }
}
</style>
